import Button from '@ui/buttons/Button'
import { MeasurementLocation } from 'hooks/measurements/useMeasureSdk'
import { useTranslation } from 'react-i18next'
import { FrameSettingsFormHook } from './useFrameSettingsForm'
import { MeasurementResult } from '@modules/brillen-sdk'
import { useCallback } from 'react'
import useSdkMeasureListener from 'hooks/measurements/useSdkMeasureListener'
import MeasurementUtils from 'utils/MeasurementUtils'
import { View } from 'react-native'
import { useMeasure } from 'features/measurements/useMeasure'

type Props = {
  form: FrameSettingsFormHook['form']
  vboxMm?: number
}

const FormMeasureSH = ({ form, vboxMm }: Props) => {
  const { t } = useTranslation(['ui'])

  const onResult = useCallback(
    (result: MeasurementResult) => {
      if (!result.faceData) return

      const parsed = MeasurementUtils.parse.sh.result(result)
      form.setValue('leftSH', parsed.left?.toString())
      form.setValue('rightSH', parsed.right?.toString())
    },
    [form]
  )

  const { onMeasure } = useMeasure('sh', {
    location: MeasurementLocation.frameSh,
    vboxMm,
    onComplete: (result) => {
      form.setValue('leftSH', result.left.toString())
      form.setValue('rightSH', result.right.toString())
    },
  })

  useSdkMeasureListener(onResult, 'sh')

  return (
    <View className="w-full flex-col items-start">
      <Button
        label={t('ui:measure')}
        onPress={() => onMeasure()}
        variant="outlined"
      />
    </View>
  )
}

export default FormMeasureSH
